import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { ProductCartEventEnum } from 'analytics/events/subscription';
import { GAEventName } from 'analytics/ga-event-name.enum';
import { CheckoutType } from './ecommerce';

type SubscriptionType = 'Subscription' | 'Subscription Double';

type ItemCategory = 'Subscription' | 'Subscription Double' | 'Gifting' | 'OTP';

export const addToNextOrder = createAnalyticsEvent<{
  add_to_cart_type: ProductCartEventEnum;
  checkout_type: CheckoutType;
  subscription_id: number;
  product_id: number;
  product_name?: string;
  product_category?: string;
  product_variant?: string;
  product_variant_id: number;
  product_quantity: number;
  product_price?: number;
}>((payload) => ({
  event: GAEventName.SUBSCRIPTION_PRODUCT_ADD,
  ...payload,
  product_variant: payload.product_variant || undefined
}));

export const replaceSubscriptionItem = createAnalyticsEvent<{
  item_name?: string;
  item_category?: ItemCategory;
  item_category_2?: string;
  item_variant?: string;
  variant_id?: number;
  price?: string;
  currency?: string;
  quantity?: number;
  type?: SubscriptionType;
}>((payload) => ({
  event: GAEventName.REPLACE_SUBSCRIPTION_ITEM,
  ...payload
}));

export const giftToggleOnShippingEvent = createAnalyticsEvent(() => ({
  event: GAEventName.TURN_ON_GIFTING_SHIPPING
}));

export const giftToggleOnOrderReviewEvent = createAnalyticsEvent(() => ({
  event: GAEventName.TURN_ON_GIFTING_ORDER_REVIEW
}));

export const productCardClickEvent = createAnalyticsEvent<{
  productId: string | number;
  productName: string;
  productPrice?: string | number;
  productVariantId?: string | number;
  productVariant?: string;
  location?: string;
}>(({ productId, productName, productPrice, productVariantId, productVariant, location }) => ({
  event: GAEventName.PRODUCT_CARD_CLICK,
  productId,
  productName,
  productPrice,
  productVariantId,
  productVariant,
  location
}));
